import { axiosGenerateReport } from "config/axios.config";

const generateReportSvc = {
  getListReport: async (body) => {
    const response = await axiosGenerateReport.post(`${'report/list/generate-report'}`, body);
    return response;
  },
  generateNewReport: async (body) => {
    const response = await axiosGenerateReport.post(`${'report/generate-report'}`, body);
    return response;
  },
}

export default generateReportSvc;